/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { useGoogleAnalytics } from 'volto-google-analytics';

import {
  FooterMainUniba,
  SubsiteFooter,
} from 'design-comuni-plone-theme/components/ItaliaTheme/';

/**
 * Footer component class.
 * @class Footer
 * @extends Component
 */

const Footer = () => {
  useGoogleAnalytics();

  return (
    <>
      <SubsiteFooter />
      <footer className="it-footer" id="footer">
        <FooterMainUniba />
      </footer>
    </>
  );
};

export default Footer;
